import { POST } from './utils';

export const assignArticle = (articleId, data): Promise<any> =>
    POST('/manualArticleAssignment', {
        articleId,
        correspondingAuthor: data.correspondingAuthor,
        note: data.note,
        selectedParticipantId: data.selectedParticipantId,
    });

export const notifyAdmin = (journalId, articleTitle, other, correspondingAuthor): Promise<any> =>
    POST('/manualArticleAssignment', {
        articleDoi: other.articleDoi,
        articleManuscriptId: other.articleManuscriptId,
        articleTitle,
        correspondingAuthor,
        journalId,
        submissionEmailAddress: other.submissionEmailAddress,
    });

export const notifyAdminMissingArticle = (data): Promise<void> => POST('/manualArticleAssignment', data);

export const notifyAdminMissingArticleRexFlow = (data): Promise<void> =>
    POST('/manualArticleAssignment/articleNotAccepted', {
        ...data,
        articleDoi: undefined,
        correspondingAuthor: undefined,
        submittingAuthor: data.correspondingAuthor,
    });
